module.exports = __webpack_public_path__ + "img/meteor_background_larvik.d7c6f4f7.jpg";